import React from 'react';

import Box from 'atoms/Box';
import Text from 'atoms/Text';

import Localized, { Strings } from 'utils/localize';

export interface DescriptionProps {}

function Description({}: DescriptionProps) {
  return (
    <Box mv={2}>
      <Text weight={700} lineHeight={1.35} align="center">
        {Localized(Strings.hint)}
      </Text>
    </Box>
  );
}

export default Description;
